import { postRequest } from "../../middlewares/api/actions";
import { getDownloadMetadatiList } from "../../constants/urls";
import { getLocalizedArtefactName } from "../../utils/artefacts";
import moment from "moment";
import { artefactType } from "../../utils/artefacts";

export const ARTEFACT_FULL_EXPORT = 'ARTEFACT_FULL_EXPORT'
export const ARTEFACT_FULL_EXPORT_SHOW = 'ARTEFACT_FULL_EXPORT_SHOW'
export const ARTEFACT_FULL_EXPORT_HIDE = 'ARTEFACT_FULL_EXPORT_HIDE'
export const ARTEFACT_FULL_EXPORT_CHANGE = 'ARTEFACT_FULL_EXPORT_CHANGE'
 
export const showArtefactFullExport = (payload) => ({
  type: ARTEFACT_FULL_EXPORT_SHOW,
  payload
});

export const hideArtefactFullExport = () => ({
  type: ARTEFACT_FULL_EXPORT_HIDE
});

export const changeArtefactFullExport= fields => ({
  type: ARTEFACT_FULL_EXPORT_CHANGE,
  fields
});

export const artefactFullExport = (artefactData, separator, delimiter, isCompressed, lang, columnsMap, path) => {
  const exportPage = path.split('meta-manager/')[1];
  const exportedArtefactType = artefactType.hasOwnProperty(exportPage) ? artefactType[exportPage] : "Artefacts";
  artefactData = artefactData.map(art => getLocalizedArtefactName(art, lang));
  const currDate = moment().format('YYYY-MM-DD_HH-mm');
  const fileSave = {
    name: `${exportedArtefactType}_Export_${currDate}_${lang}.${isCompressed ? 'zip' : 'csv'}`,
    type: "text/plain;charset=utf-8"
  };
  return {
      ...postRequest(
        ARTEFACT_FULL_EXPORT,
        getDownloadMetadatiList(isCompressed, separator, delimiter, exportedArtefactType, lang),
        {
          artefacts: artefactData,
          headers: columnsMap[lang]
        },
        undefined,
        undefined,
        true
      ),
      fileSave
  }
}